
import { useEffect, useState, useRef } from "react";
import { inject, observer } from 'mobx-react';
import { Card, Button, ModalAlert, FormLoading, Input } from '../../components'
import { SearchIcon } from '@heroicons/react/outline'
import { DatePicker } from 'antd';
import { UploadQueueService, QueueService } from "../../services";
import { CloudDownloadIcon, PlusIcon, SaveIcon, TrashIcon, UploadIcon } from "@heroicons/react/solid";
import DataGrid, { Paging, Column, Scrolling } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import './style.css'
import ModalQueue from '../Plan/ModalQueue'
import ModalEditUpload from './ModalEditUpload'
import TableUpload from "./TableUpload";
import TableQueue from "./TableQueue";
import moment from 'moment'
import { BASE_URL } from '../../AppConfig'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'

const UploadJobV2 = inject("authenStore", "commonStore")(observer((props) => {
  const { t } = useTranslation(['uploadjob', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const inputRef: any = useRef(null);
  const [importReady, setImportReady] = useState(false)
  const [importId, setImportId] = useState("")
  const [uploadId, setUploadId] = useState("")
  const [uploadStore, setUploadStore]: any = useState(null)
  const [uploadSummary, setUploadSummary] = useState({ total: 0, pass: 0, fail: 0 })
  const PAGE_SIZE = 50
  const [openAddQueue, setOpenAddQueue] = useState(false)
  const [openEditQueue, setOpenEditQueue] = useState({
    show: false,
    data: {}
  })
  const [loading, setLoading] = useState({ visible: false, tip: "กำลังโหลด" })
  const [fileUploadName, setFileUploadName] = useState("")
  const [documents, setDocuments]: any = useState([])
  const [showTableName, setShowTableName] = useState("upload")
  const [dataUpload, setDataUpload]: any = useState([])
  const [dataQueue, setDataQueue]: any = useState([])
  const [dataEdit, setDataEdit]: any = useState({})
  const [dateSearch, setDateSearch]: any = useState("")
  const [queueSelected, setQueueSelected]: any = useState([])
  const [queueDateCurrent, setQueueDateCurrent]: any = useState("")
  const [refNo, setRefNo]: any = useState("")
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],

    }
  })


  useEffect(() => {

    getDocuments()
  }, [])

  const initialData = () => {
    setQueueSelected("")
    setDataEdit({})
  }


  const getDocuments = () => {
    UploadQueueService.getDocuments()
      .then((res: any) => {
        setDocuments(res.result)
      })
      .catch((err) => {

      })
  }


  // BUILD REMOTE-PAGING STORE FOR UPLOADED RECORDS
  const buildUploadStore = (upId, totalRecords) => new CustomStore({
    key: 'id',
    load: async (loadOptions: any) => {
      const take = loadOptions.take || PAGE_SIZE
      const skip = loadOptions.skip || 0
      const page = Math.floor(skip / take) + 1
      const res: any = await UploadQueueService.getFastUploadList(auth, upId, page, take)
      const records = res?.result?.records || res?.result || []
      const totalCount = res?.result?.total_records ?? res?.result?.total_count ?? totalRecords
      return { data: records, totalCount }
    }
  })

  const reloadUploadList = async () => {
    if (!uploadId) return
    try {
      // ดึง summary + import_ready ล่าสุดจากเส้น list (page 1)
      const res: any = await UploadQueueService.getFastUploadList(auth, uploadId, 1, PAGE_SIZE)
      const r = res?.result || {}
      setUploadSummary({
        total: r.total_records ?? r.total_count ?? uploadSummary.total,
        pass: r.pass_count ?? r.valid_count ?? uploadSummary.pass,
        fail: r.fail_count ?? r.invalid_count ?? uploadSummary.fail
      })
      setImportReady(r.import_ready === 1)
      setUploadStore(buildUploadStore(uploadId, r.total_records ?? r.total_count ?? uploadSummary.total))
    } catch (err) {
      // ถ้าดึง summary ไม่สำเร็จ อย่างน้อยรีโหลดตาราง
      setUploadStore(buildUploadStore(uploadId, uploadSummary.total))
    }
  }

  // CLEAR INPUT UPLOAD + STORE + SUMMARY
  const clearUpload = () => {
    setFileUploadName("")
    setUploadStore(null)
    setUploadSummary({ total: 0, pass: 0, fail: 0 })
    setDataUpload([])
    setImportReady(false)
    setUploadId("")
    setImportId("")
  }

  const handleFileChange = (e) => {
    if (!e.target.files) return;

    setShowTableName("upload")
    setDataQueue([])
    // VALIDATE FILE UPLOAD
    let isError = false
    const fileLists = Array.from(e.target?.files)
    fileLists.map((file: any) => {
      let nameSplite = file.name.split('.')
      let fileType = nameSplite[(nameSplite.length - 1)]
      setFileUploadName(file.name)
      if (!["xls", "xlsx"].includes(fileType)) {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "อัปโหลดไฟล์ผิดพลาด",
          description: { visible: true, type: "text", content: `สามารถอัปโหลดไฟล์เฉพาะ Excel  เท่านั้น` }
        })

        isError = true
      }
    })

    if (!isError) {
      setLoading({ ...loading, visible: true, tip: 'กำลังตรวจสอบข้อมูล' })

      const data = new FormData();
      fileLists.forEach((file: any, i) => {
        data.append('files', file, file.name);
      });
      UploadQueueService.fastUpload(auth, data)
        .then((data: any) => {
          let { message, sys_message } = data
          if (data.code === 200) {
            const r = data?.result
            setImportId(r.imp_id)
            setUploadId(r.upload_id)
            setImportReady(r.import_ready === 1 && r.total_records > 0 ? true : false)
            setDataUpload(r)
            setUploadSummary({
              total: r.total_records ?? r.total_count ?? 0,
              pass: r.pass_count ?? r.valid_count ?? 0,
              fail: r.fail_count ?? r.invalid_count ?? 0
            })
            setUploadStore(buildUploadStore(r.upload_id, r.total_records ?? r.total_count ?? 0))
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoading({ ...loading, visible: false, tip: '' })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading({ ...loading, visible: false, tip: '' })
        })
    }
    e.target.value = '';
  }

  const importData = () => {
    setLoading({ ...loading, visible: true, tip: 'กำลังนำเข้า...' })

    UploadQueueService.importFast(auth, uploadId, importId)
      .then((res: any) => {
        let { code, message } = res.data
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "นำเข้าข้อมูลสำเร็จ",
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          clearUpload()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "นำเข้าข้อมูลไม่สำเร็จ",
            description: { visible: true, type: "text", content: message }
          })
        }
        setLoading({ ...loading, visible: false, tip: '' })
      })
      .catch((err) => {
        console.log("err  :", err)
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "นำเข้าข้อมูลไม่สำเร็จ",
          description: { visible: true, type: "text", content: `${err}` }
        })
        setLoading({ ...loading, visible: false, tip: '' })
      })
  }


  const deleteUpload = (id) => {
    UploadQueueService.deleteQueue(auth, id)
      .then((res: any) => {
        let { code, message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          reloadUploadList()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: message }
          })
        }

      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }


  //#region QUEUE MANAMENT
  const deleteQueue = (qSelected) => {
    let qids = ""
    if (qSelected.length > 0) qids = qSelected.join(',')

    QueueService.deleteQueue(auth, qids)
      .then((res: any) => {
        let { code, message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          searchQueue()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: true, type: "text", content: message }
          })
        }
        initialData()
      })
      .catch((err) => {

      })
  }

  const searchQueue = (date = "") => {
    // setLoading({ ...loading, visible: true, tip: 'loading' })
    // setTimeout(() => setLoading({ ...loading, visible: false, tip: '' }), 1000)
    // setDataQueue(DATA_QUEUE)
    setLoading({ ...loading, visible: true, tip: 'loading' })
    setShowTableName("queue")
    setDataUpload([])


    let delivery_date = date === "" ? dateSearch : date
    setQueueDateCurrent(delivery_date)
    QueueService.getQueue(auth, { delivery_date, id_refno: refNo })
      .then((res: any) => {
        let { code, message, result, sys_message } = res
        if (code === 200) {
          setDataQueue(result)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false, tip: 'loading' })
      })
      .catch((err) => {
        console.log("err  :", err)
        setLoading({ ...loading, visible: false, tip: 'loading' })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  //#endregion



  return (
    <div className="space-y-3 p-3">
      <Card title={t('นำเข้างาน V2')}>
        <FormLoading loading={loading.visible} tip={loading.tip}>

          {/* ✅ Tablet และ Mobile = แนวตั้ง | Desktop (lg) = แนวนอน */}
          <div className="flex flex-col lg:flex-row h-auto lg:h-[calc(100vh-178px)]">

            {/* ===== LEFT PANEL ===== */}
            <div className="shrink-0 w-full lg:w-72 p-2 flex-col space-y-2">

              {/* Upload Row */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2">

                {/* Input File Name */}
                <span className="inline-flex items-start text-sm font-normal w-full sm:flex-1">
                  <input
                    type="text"
                    placeholder={t('เลือกไฟล์')}
                    className="block w-full h-7 rounded-md shadow-sm border-gray-300 placeholder-gray-400 bg-gray-100 sm:text-sm truncate"
                    value={fileUploadName}
                    disabled
                  />
                  <input
                    id="input-upload"
                    className="hidden"
                    type="file"
                    ref={inputRef}
                    onChange={handleFileChange}
                  />
                </span>

                {/* Buttons */}
                <div className="flex gap-2 shrink-0">
                  <Button
                    iconOnly={<UploadIcon />}
                    size="sm"
                    type="white"
                    title="อัปโหลด"
                    onClick={() => inputRef.current.click()}
                  />

                  <Button
                    iconOnly={<CloudDownloadIcon />}
                    size="sm"
                    type="white"
                    title={t('download_template')}
                    onClick={() => window.open(`${BASE_URL}/queue_imp/excel`)}
                  />
                </div>

              </div>


              {/* DataGrid */}
              <div className="overflow-auto">
                <DataGrid
                  dataSource={documents}
                  keyExpr="id"
                  height={'calc(100vh - 230px)'}
                  allowColumnReordering
                  hoverStateEnabled
                  columnAutoWidth
                  wordWrapEnabled
                  showBorders
                >
                  <Scrolling columnRenderingMode="virtual" />
                  <Paging enabled={false} />

                  <Column
                    dataField="upload_date"
                    caption={t('วันที่')}
                    cellRender={(e) => moment(e.value).format('DD/MM/YYYY')}
                  />
                  <Column dataField="filename" caption={t('ชื่อไฟล์')} />
                </DataGrid>
              </div>
            </div>

            {/* ===== RIGHT PANEL ===== */}
            <div className="flex-1 w-full border-t lg:border-t-0 lg:border-l border-bold pt-2 px-2 space-y-2 overflow-auto">

              {/* HEADER ACTION BAR */}
              <div className="flex flex-col gap-2">

                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm">{t('วันที่')} :</span>

                  <DatePicker
                    allowClear={false}
                    className="w-full h-7 sm:w-40"
                    placeholder={t('วันที่')}
                    onChange={(d) => setDateSearch(d ? d.format("YYYY-MM-DD") : "")}
                  />

                  <Input
                    label={t('เลขที่ใบสั่งงาน')}
                    placeholder={t('เลขที่ใบสั่งงาน')}
                    hiddenLabel
                    size="xs"
                    onChange={(e) => setRefNo(e.target.value)}
                    className="w-full sm:w-48"
                  />

                  <Button
                    iconOnly={<SearchIcon />}
                    size="sm"
                    type="white"
                    title={t('search')}
                    onClick={() => {
                      if (dateSearch === "") {
                        setOptionAlert({
                          ...optionAlert,
                          action: {
                            id: "",
                            name: ""
                          },
                          type: "info",
                          title: "โปรดระบุวันที่",
                          show: true,
                          description: {
                            visible: false,
                            type: "text",
                            content: "",
                            contentLists: []
                          }
                        })
                      }
                      else {
                        clearUpload()
                        searchQueue()
                      }
                    }}
                  />

                  <Button
                    text={t('เพิ่มข้อมูลใบส่งสินค้า')}
                    icon={<PlusIcon />}
                    size="sm"
                    type="white"
                    iconPosition="start"
                    onClick={() => setOpenAddQueue(true)}
                  />

                  {showTableName === "queue" && (
                    <Button
                      text="ลบข้อมูลใบส่งสินค้า"
                      icon={<TrashIcon />}
                      size="sm"
                      type="white"
                      iconPosition="start"
                      onClick={() => {
                        if (queueSelected.length === 0) {
                          setOptionAlert({
                            ...optionAlert,
                            action: {
                              id: "",
                              name: ""
                            },
                            type: "info",
                            title: "โปรดเลือกคิวที่ต้องการลบ",
                            show: true,
                            description: {
                              visible: false,
                              type: "text",
                              content: "",
                              contentLists: []
                            }
                          })
                        }
                        else {
                          setOptionAlert({
                            ...optionAlert,
                            action: {
                              id: "",
                              name: 'deleteQueue'
                            },
                            type: "confirm",
                            title: t('common:confirm'),
                            show: true,
                            description: {
                              visible: true,
                              type: "text",
                              content: t('common:confirm_delete_data'),
                              contentLists: []
                            }
                          })
                        }
                      }
                      }
                    />
                  )}
                </div>

                {/* IMPORT BTN */}
                <div className={`flex justify-end ${!importReady && 'sr-only'}`}>
                  <Button
                    text="นำเข้า"
                    icon={<SaveIcon />}
                    size="sm"
                    width="w-20"
                    type="primary"
                    onClick={() => setOptionAlert({
                      ...optionAlert,
                      action: {
                        id: "",
                        name: 'import'
                      },
                      type: "confirm",
                      title: t('common:confirm'),
                      show: true,
                      description: {
                        visible: true,
                        type: "text",
                        content: t('common:save_the_data'),
                        contentLists: []
                      }
                    })}
                  />
                </div>
              </div>

              {/* ===== SUMMARY ===== */}
              {showTableName === "upload" && uploadSummary.total > 0 && (
                <div className="flex flex-wrap items-center gap-4 text-sm border rounded-md bg-gray-50 px-3 py-2">
                  <span>{t('all')} : <b>{uploadSummary.total}</b></span>
                  <span className="text-success-600">{t('pass')} : <b>{uploadSummary.pass}</b></span>
                  <span className="text-danger-600">{t('fail')} : <b>{uploadSummary.fail}</b></span>
                </div>
              )}

              {/* ===== TABLE ZONE ===== */}
              {showTableName === "upload" ? (
                <TableUpload
                  dataSource={uploadStore}
                  pageSize={PAGE_SIZE}
                  optionAlert={openEditQueue}
                  setOpenEditQueue={(data) => setOpenEditQueue({
                    ...openEditQueue,
                    show: true,
                    data
                  })}
                  onDelete={(id) => setOptionAlert({
                    ...optionAlert,
                    action: {
                      id,
                      name: 'delete'
                    },
                    type: "confirm",
                    title: t('common:confirm'),
                    show: true,
                    description: {
                      visible: true,
                      type: "text",
                      content: t('common:confirm_delete_data'),
                      contentLists: []
                    }
                  })}
                />
              ) : (
                <TableQueue
                  dataSource={dataQueue}
                  optionAlert={openEditQueue}
                  height="auto"
                  onSelectionChanged={(select) => setQueueSelected(select)}
                  onEdit={(data) => {
                    data.actionBy = "queue"
                    data.actionPage = 'upload'
                    setDataEdit(data)
                    setOpenAddQueue(true)
                  }}
                />
              )}
            </div>
          </div>
        </FormLoading>
      </Card>

      <ModalQueue
        auth={auth}
        open={openAddQueue}
        mode={isEmpty(dataEdit) ? "add" : "edit"}
        dataEdit={dataEdit}
        onClosed={(reload, delivery_date) => {
          if (delivery_date === queueDateCurrent) searchQueue(delivery_date)
          setOpenAddQueue(false)
          setDataEdit({})
        }}
      />
      <ModalEditUpload
        auth={auth}
        open={openEditQueue.show}
        data={openEditQueue.data}
        onClosed={(reload) => {
          reload && reloadUploadList()
          setOpenEditQueue({ ...openEditQueue, data: {}, show: false })
        }}
      />

      <ModalAlert
        {...optionAlert}
        onOk={async () => {
          let { action } = optionAlert
          if (action.name === "import") {
            importData()
          }
          else if (action.name === "delete") {
            deleteUpload(action.id)
          }
          else if (action.name === "deleteQueue") {
            deleteQueue(queueSelected)
          }
          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </div>
  )
}))

export default UploadJobV2